import { render, staticRenderFns } from "./Attributes.vue?vue&type=template&id=c58325c0&scoped=true"
import script from "./Attributes.vue?vue&type=script&lang=js"
export * from "./Attributes.vue?vue&type=script&lang=js"
import style0 from "./Attributes.vue?vue&type=style&index=0&id=c58325c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58325c0",
  null
  
)

export default component.exports